import { getClient } from '@aries-markets/api';

export const ariesApi = getClient('https://api-v2.ariesmarkets.xyz');
